<app-disconnect-overlay></app-disconnect-overlay>
<app-mic-permission-overlay></app-mic-permission-overlay>
<app-audio-debugger></app-audio-debugger>

@if (this.fullscreenActive) {
<div class="avatar-fullscreen">
  <app-avatar-fullscreen-header
    [header]="this.botConfig.liveAvatarConfig?.fullscreenConfig?.header"></app-avatar-fullscreen-header>
  <div
    #fullscreenContent
    class="avatar-fullscreen-content"
    [style.background-image]="this.backgroundUrl ? 'url(' + this.backgroundUrl + ')' : 'none'"
  >
    <ng-container *ngTemplateOutlet="avatarMedia"></ng-container>
    <ng-container *ngTemplateOutlet="underVideoStatus"></ng-container>
  </div>
  <div class="avatar-fullscreen-footer">
    <div class="avatar-fullscreen-footer-row avatar-fullscreen-footer-row-input">
      <ng-container *ngTemplateOutlet="underVideoInput"></ng-container>
    </div>
    <div class="avatar-fullscreen-footer-row avatar-fullscreen-footer-row-buttons">
      @if (this.viewState === 'INITIAL') {
      <button
        class="btn btn-primary btn-sm"
        (click)="connectLiveAvatar()"
      >
        <span i18n="@@avatar-fullscreen-start-conversation">Gespräch starten</span>
      </button>
      }
      @if (this.viewState === 'CONNECTING') {
      <div
        class="btn btn-danger btn-sm"
        (click)="disconnectLiveAvatar()"
      >
        <span i18n="@@cancel">Abbrechen</span>
      </div>
      }
      <app-avatar-fullscreen-footer-buttons></app-avatar-fullscreen-footer-buttons>
    </div>
  </div>
</div>
} @else {
<table>
  <tr>
    <td>
      <div class="contentHolder">
        <ng-container *ngTemplateOutlet="overVideo"></ng-container>
        <ng-container *ngTemplateOutlet="avatarMedia"></ng-container>
        <ng-container *ngTemplateOutlet="underVideoStatus"></ng-container>
        <ng-container *ngTemplateOutlet="underVideoInput"></ng-container>
      </div>
    </td>
  </tr>
</table>
}

<ng-template #avatarMedia>
  <div class="media-holder">
    <div id="interactionButtonsHolder">
      @if (this.viewState === 'INITIAL' && !this.fullscreenActive) {
      <button
        class="btn btn-danger bg-white px-3 py-3 text-danger border-0 connect-video-avatar"
        [ngStyle]="{
                          '--media-width': this.mediaWidth + 'px',
                          '--media-height': this.mediaHeight + 'px'
                      }"
        (click)="connectLiveAvatar()"
      >
        <i class="ri-vidicon-fill ri-2x"></i><br>
        <span i18n="@@liveavatar-connect">Video verbinden</span>
      </button>
      }

      @if (this.viewState === 'CONNECTING') {
      <div
        class="text-center spinner-container"
        [ngStyle]="{
                          '--media-width': this.mediaWidth + 'px',
                          '--media-height': this.mediaHeight + 'px'
                      }"
      >
        <div class="spinner-holder">
          <div
            class="spinner-border"
            [ngStyle]="{
                                  '--media-width': this.mediaWidth + 'px',
                                  '--media-height': this.mediaHeight + 'px'
                              }"
            role="status"
          >
            <span
              class="visually-hidden"
              i18n="@@loading"
            >Loading...</span>
          </div>
        </div>
      </div>
      }
    </div>

    @if (this.viewState !== 'CONNECTED') {
    <div
      id="previewImage"
      [ngClass]="{'connecting': this.viewState === 'CONNECTING'}"
      [ngStyle]="{'width': this.mediaWidth + 'px', 'height': this.mediaHeight + 'px'}"
      [style.background-image]="!this.fullscreenActive && this.effectiveGreenscreen && this.backgroundUrl ? 'url(' + this.backgroundUrl + ')' : 'none'"
    >
      @if (this.botConfig.liveAvatarConfig?.avatarPreviewUrl) {
      <img
        alt="Avatar Vorschau"
        [src]="this.botConfig.liveAvatarConfig!.avatarPreviewUrl"
      >
      }
    </div>
    }

    <div
      #videoWrapper
      id="videoWrapper"
      [class.d-none]="this.viewState !== 'CONNECTED'"
    >
      <div
        #backgroundImage
        class="bg-image"
        [style.background-image]="!this.fullscreenActive && this.effectiveGreenscreen && backgroundUrl ? 'url(' + backgroundUrl + ')' : 'none'"
      ></div>
      <video
        #videoElement
        class="source-video"
        playsinline
        autoplay
        [style.opacity]="this.effectiveGreenscreen ? '0' : '1'"
        (loadedmetadata)="onVideoLoadedMetadata()"
        (playing)="onVideoPlaying()"
      ></video>
      <canvas
        #canvasElement
        [class.d-none]="this.viewState !== 'CONNECTED' || !this.effectiveGreenscreen"
      ></canvas>
    </div>
  </div>
</ng-template>

<ng-template #overVideo>
  <div class="row mb-1 align-items-center">
    <div class="col text-start">
      @if (this.viewState === 'INITIAL') {
      {{this.botConfig.name}}
      }
      @if (this.viewState !== 'CONNECTED') {
      <i
        class="ri-circle-fill"
        [ngStyle]="{'visibility': this.viewState === 'CONNECTING' ? 'visible' : 'hidden'}"
      ></i>
      @if (this.viewState === 'CONNECTING') {
      <span i18n="@@liveavatar-connecting">Avatar wird verbunden…</span>
      }
      }
      @if (this.viewState === 'CONNECTED') {
      <i class="ri-circle-fill text-primary me-1"></i>
      <span i18n="@@online">Online</span>
      @if (this.botState === 'generating_audio') {
      <span
        class="ms-1 avatar-status"
        i18n="@@liveavatar-generating-audio"
      >Sprachausgabe wird erzeugt…</span>
      }
      @if (this.botState === 'speaking') {
      <span
        class="ms-1 avatar-status"
        i18n="@@liveavatar-avatar-speaking"
      >Avatar spricht…</span>
      }
      @if (this.botState !== 'idle' && this.botState !== 'speaking' && this.botState !== 'generating_audio') {
      <span
        class="ms-1 avatar-status"
        i18n="@@thinking"
      >moment</span>
      }
      }
    </div>
    <div class="col-auto">
      @if (this.viewState === 'CONNECTED') {
      <button
        class="btn btn-danger btn-sm"
        (click)="disconnectLiveAvatar()"
      >
        <i class="ri-video-off-fill me-1"></i>
        <span i18n="@@endVideo">Video beenden</span>
      </button>
      }
      @if (this.viewState === 'INITIAL') {
      <div class="btn btn-danger btn-sm invisible">
        <i class="ri-video-off-fill me-1"></i>
        <span i18n="@@cancel">Abbrechen</span>
      </div>
      }
      @if (this.viewState === 'CONNECTING') {
      <div
        class="btn btn-danger btn-sm"
        (click)="disconnectLiveAvatar()"
      >
        <i class="ri-video-off-fill me-1"></i>
        <span i18n="@@cancel">Abbrechen</span>
      </div>
      }
    </div>
  </div>
</ng-template>

<ng-template #underVideoStatus>
  @if (this.viewState === 'CONNECTED') {
  <p class="voice-bar-status">
    @if (!hasOverrideText()) {
    @if (this.attService.state.getValue() === 'connecting') {
    <span i18n="@@liveavatar-att-connecting">Verbinde Mikrofon…</span>
    }
    @if (this.attService.state.getValue() === 'thinking') {
    <span i18n="@@liveavatar-att-thinking">Verarbeite…</span>
    }
    @if (this.attService.state.getValue() === 'sending') {
    <span i18n="@@liveavatar-att-sending">Sende…</span>
    }
    @if (this.attService.state.getValue() === 'listening' && playService.state !== 'play' && this.botState !==
    'speaking' && this.botState !== 'generating_audio') {
    <span i18n="@@liveavatar-att-listening">Ich höre zu</span>
    }
    @if (this.botState === 'generating_audio') {
    <span i18n="@@liveavatar-generating-audio">Sprachausgabe wird erzeugt…</span>
    }
    @if (this.botState === 'speaking') {
    <span i18n="@@liveavatar-avatar-speaking">Avatar spricht…</span>
    }
    @if (this.attService.speakingState.getValue() || playService.state === 'play') {
    <span i18n="@@talk-to-interrupt-2"> - zum unterbrechen reden</span>
    }
    } @else {
    <span>{{getOverWriteText()}}</span>
    }
  </p>
  }
</ng-template>

<ng-template #underVideoInput>
  @if (this.viewState === 'CONNECTED') {
  <div class="chat-input px-1 py-1">
    @if (!this.botConfig.liveAvatarConfig?.promptbarActive) {
    <app-voice-bars></app-voice-bars>
    }
    @if (this.botConfig.liveAvatarConfig?.promptbarActive) {
    <app-bot-prompt
      [botConfig]="this.botConfig"
      [isThinking]="this.botState !== 'idle'"
      [cancelThinking]="!!this.botConfig.liveAvatarConfig?.cancelBotThinkingActive"
      [voiceInput]="false"
      [switchToChat]="!!this.botConfig.liveAvatarConfig?.switchToChat"
      [switchToVoice]="!!this.botConfig.liveAvatarConfig?.switchToVoice"
      [(promptInput)]="this.myWords"
      (sendPrompt)="this.sendMyWords()"
      (stfu)="this.cancelThinking()"
    ></app-bot-prompt>
    }
    <button
      class="btn-mute cursor-pointer btn switchto-btn ms-2 flex-shrink-0"
      [ngClass]="{'muted': this.attService.isMuted}"
      [attr.aria-label]="this.muteButtonLabel"
      (click)="attService.setMuted(!this.attService.isMuted)"
    >
      <i
        [ngClass]="{
                    'ri-mic-off-line': this.attService.isMuted,
                    'ri-mic-line': !this.attService.isMuted
                }"
        aria-hidden="true"
      ></i>
    </button>
  </div>
  }
</ng-template>

<ng-template #avatarOverwriteText>
  <span>{{getOverWriteText()}}</span>
</ng-template>